import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { RefreshSessionService } from "../../services/auth";
import store from "../../store";
import { logoutUser, logoutUserSuccess } from "../../store/auth/actions";
import { RefreshSession } from "../endpoints";
import { cookieStore } from 'cookie-store';

const delete_cookie = function(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

const headers = {};

if (localStorage.getItem("jwt")) {
  headers["Authorization"] = `jwt ${localStorage.getItem("jwt")}`;
}

const BASE_URL = window.location.hostname.split(".")[1] == "clevai" ?
  "https://staging.sparkbackend.cerebry.co/api/v3/admin/competitions" :
  "https://staging.sparkbackend.cerebry.co/api/admin/competitions";

const Axios = axios.create({
  baseURL: BASE_URL,
  // baseURL: "https://develop.sparkbackend.cerebry.co/api/admin/competitions",
  headers: {
    "content-Type": "application/json",
    ...headers,
  },
});

// Function that will be called to refresh authorization
const refreshAuthLogic = async (failedRequest) => {
  try {
    let headers = {};
    cookieStore.get("cerebry-jwt-token").then((e)=>{
      // Deleting expired jwt token from cookies
      delete_cookie("cerebry-jwt-token");
      if(e==null){
        if (localStorage.getItem("jwt_refresh")) {
          headers["Authorization"] = `jwt ${localStorage.getItem("jwt_refresh")}`;
        }
      }
      else{
        headers["Authorization"] = `jwt ${e.value}`;
      }
      axios.defaults.baseURL = BASE_URL;
      axios.defaults.headers = headers;
    axios.post(RefreshSession, {
      skipAuthRefresh: true,
    }).then((e)=>{
      if (e.status < 400) {
        const { jwt } = e.data;
        localStorage.setItem("jwt", jwt);
        // Adding new JWT token in cookies
        cookieStore.set("cerebry-jwt-token",jwt)
        failedRequest.response.config.headers["Authorization"] = "jwt " + jwt;
        return Promise.resolve();
      } else {
        localStorage.clear();
        Axios.defaults.headers["Authorization"] = "";
        store.dispatch(logoutUserSuccess());
        return Promise.reject();
      }
    }).catch((e)=>{
      localStorage.clear();
      Axios.defaults.headers["Authorization"] = "";
      delete_cookie("cerebry-jwt-token");
      delete_cookie("cerebry-jwt-refresh");
      store.dispatch(logoutUserSuccess());
      return Promise.reject();
    })
  })
  } catch (error) {
    localStorage.clear();
    Axios.defaults.headers["Authorization"] = "";
    store.dispatch(logoutUserSuccess());
    return Promise.reject();
  }
};

// Instantiate the interceptor
createAuthRefreshInterceptor(Axios, refreshAuthLogic);

Axios.interceptors.response.use(
  (response) => response,
  (responsePostRefresh) => {
    const data = {
      message: responsePostRefresh?.message || responsePostRefresh,
    };
    if (responsePostRefresh?.data?.message) {
      //  in case of responsePostRefresh just after refreshing token
      data.message = responsePostRefresh.data.message;
    }
    if (Array.isArray(responsePostRefresh?.response?.data)) {
      data.message = responsePostRefresh.response.data[0];
    }
    if (responsePostRefresh?.response?.data?.non_field_errors) {
      data.message = responsePostRefresh.response.data.non_field_errors[0];
    }
    if (responsePostRefresh?.response?.data?.detail) {
      data.message = responsePostRefresh.response.data.detail;
    }
    if (responsePostRefresh?.response?.data?.password) {
      data.message = responsePostRefresh.response.data.password[0];
    }
    throw { data };
  }
);

export default Axios;
